export enum EBroker {
    ALL = 'ALL',
    MAS = 'MAS',
    LOG = 'LOG',
    EPACES = 'EPACES',
}
